// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__2mWr_","dragIcon":"Choice_dragIcon__UDVXq","left":"Choice_left__3wWm6","input":"Choice_input__2PG5g"};